import React from 'react';

const RandomizerObjectRotation = ({ state, callbacks }) => {
  return (
    <div className="w-full bg-transparent p-0 space-y-4">
      <p className="text-sm text-dark-text-muted leading-relaxed">
        Die Rotation der Objekte wird bei jedem Frame zufällig innerhalb des definierten Bereichs geändert.
      </p>

      {state.randomizers.objectRotation && (
        <div>
          <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Rotationsbereich (in Grad)</label>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <label className="text-xs text-dark-text-muted tracking-tight font-medium">Minimum</label>
              <input
                type="number"
                value={state.modelSpawn.minRotation}
                onChange={(e) => callbacks.setModelSpawn({ ...state.modelSpawn, minRotation: parseFloat(e.target.value) || 0 })}
                min="-180"
                max="180"
                step="1"
                className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
              />
            </div>
            <div className="space-y-1.5">
              <label className="text-xs text-dark-text-muted tracking-tight font-medium">Maximum</label>
              <input
                type="number"
                value={state.modelSpawn.maxRotation}
                onChange={(e) => callbacks.setModelSpawn({ ...state.modelSpawn, maxRotation: parseFloat(e.target.value) || 360 })}
                min="-180"
                max="180"
                step="1"
                className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RandomizerObjectRotation;
